import { render, staticRenderFns } from "./DrowningHeader.vue?vue&type=template&id=74c22baa&scoped=true"
import script from "./DrowningHeader.vue?vue&type=script&lang=js"
export * from "./DrowningHeader.vue?vue&type=script&lang=js"
import style0 from "./DrowningHeader.vue?vue&type=style&index=0&id=74c22baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c22baa",
  null
  
)

export default component.exports